import type { TourDefinition } from "@/types/tour";

function openReportDropdown() {
  const trigger = document.querySelector<HTMLElement>(
    '[data-tour-id="committee-report-button"]'
  );
  if (trigger) trigger.click();
}

function closeReportDropdown() {
  document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true }));
}

export const committeeSessionTour: TourDefinition = {
  id: "committee-session",
  context: "terminus-admin",
  version: 1,
  manual: true,
  steps: [
    {
      element: '[data-tour-id="committee-post-report-bar"]',
      popover: {
        title: "Post-Committee Report",
        description:
          "Shows approved and rejected solution counts. Generate the post-committee report here, or create projects from approved solutions.",
      },
    },
    {
      element: '[data-tour-id="committee-report-button"]',
      popover: {
        title: "Download & regenerate",
        description:
          "Download the current post-committee report or force a full regeneration once decisions have been updated.",
      },
      onHighlightStarted: openReportDropdown,
      onDeselected: closeReportDropdown,
    },
    {
      element: '[data-tour-id="committee-post-session-minutes"]',
      popover: {
        title: "Session Minutes",
        description:
          "Record meeting notes and upload the transcript file. Both are used to enrich the AI-generated report.",
      },
    },
    {
      element: '[data-tour-id="committee-post-decisions-tree"]',
      popover: {
        title: "Committee Decisions",
        description:
          "Vote on each opportunity and solution. Approved solutions unlock report generation and project creation.",
      },
    },
  ],
};
